import React from "react";
import { Link } from "react-router-dom";

import { toAbsoluteUrl } from "../../globals/utils/toAbsoluteUrl";
import {
  APPLICATION_LINKS,
  ROUTE_FAQS,
  ROUTE_FEEDBACK,
} from "../../globals/constants";

import "./Footer.scss";

const Footer = () => {
  return (
    <div className="Footer d-flex justify-content-around align-items-center">
      <div className="Footer__LogoContainer d-none d-lg-block">
        {/* <img
          className="Footer__LogoContainer-logo"
          src={toAbsoluteUrl("/assets/png/poonawalla__entrust.png")}
          alt="Secured By Entrust"
        /> */}
      </div>

      <div className="Footer__LinkContainer d-flex flex-column flex-lg-row flex-grow-1 flex-lg-grow-0 justify-content-around align-items-lg-center p-4 p-lg-0">
        <Link to={ROUTE_FAQS}>FAQs</Link>
        <Link to={ROUTE_FEEDBACK}>Feedback</Link>
        <a href={APPLICATION_LINKS.CONTACT_US} target="blank">
          Contact Us
        </a>
        <a href={APPLICATION_LINKS.ABOUT_US} target="blank">
          About Us
        </a>
        <a href={APPLICATION_LINKS.PRIVACY_POLICY} target="blank">
          Privacy Policy
        </a>
      </div>

      <div className="d-none d-lg-block"></div>
    </div>
  );
};

export default Footer;
